export default __webpack_public_path__ + "static/media/iconCopyLink.802dee89.svg";